import { CalendarSchedulesModel, ClassGroupModel, ClassModelSchedules, StudentGroupModel } from "@/models";
import { GetterTree } from "vuex";
import { CalendarFilter, TeacherState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";
import { FetchOngoingSessionModel } from "@/services";
import { ResourceModel } from "@/models/resource.model";

const getters: GetterTree<TeacherState, any> = {
  //classesSchedules
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CLASSES_SCHEDULES)](state: TeacherState): Array<ClassModelSchedules> {
    return state.classesSchedules;
  },
  //classesSchedulesAllSchool
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CLASSES_SCHEDULES_ALL_SCHOOL)](state: TeacherState): Array<ClassModelSchedules> {
    return state.classesSchedulesAllSchool;
  },
  //schools
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_SCHOOLS)](state: TeacherState): Array<ResourceModel> {
    return state.schools;
  },
  //acceptPolicy
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_ACCEPT_POLICY)](state: TeacherState): boolean {
    return state.acceptPolicy;
  },
  //calendarSchedules
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CALENDAR_SCHEDULES)](state: TeacherState): Array<CalendarSchedulesModel> {
    return state.calendarSchedules;
  },
  //currentSchoolId
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CURRENT_SCHOOL_ID)](state: TeacherState): string {
    return state.currentSchoolId;
  },
  //classSetUpStudents
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CLASS_SET_UP_STUDENTS)](state: TeacherState): Array<StudentGroupModel> {
    return state.classSetUpStudents;
  },
  //classGroup
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CLASS_GROUP)](state: TeacherState): Array<ClassGroupModel> {
    return state.classGroup;
  },
  //calendarFilter
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_CALENDAR_FILTER)](state: TeacherState): CalendarFilter {
    return state.calendarFilter;
  },
  //isHelper
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_IS_HELPER)](state: TeacherState): boolean {
    return state.isHelper;
  },
  //getIgnoreHelperRequestJoinClass
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_IGNORE_HELPER_REQUEST_JOIN_CLASS)](state: TeacherState): boolean {
    return state.ignoreHelperRequestJoinClass;
  },
  //isHelperTakingOver
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_IS_HELPER_TAKING_OVER)](state: TeacherState): boolean {
    return state.isHelperTakingOver;
  },
  [defineVuexName(MODULES.TEACHER.GETTERS.GET_ONGOING_SESSION)](state): FetchOngoingSessionModel | null {
    return state.ongoingSession;
  },
};

export default getters;
